import { Layers, Ruler, Route, X, GitCompareArrows, Download, Loader2 } from "lucide-react";
import { LAYERS, SURVEY_YEARS } from "../../lib/sampleLake";

const VISIBLE_LAYERS = Object.values(LAYERS).filter((l) => !l.hidden);

const Chip = ({ active, onClick, children, testId, tone = "cyan" }) => (
  <button
    type="button"
    data-testid={testId}
    aria-pressed={active}
    onClick={onClick}
    className={`px-3.5 py-2 rounded-lg text-sm font-semibold border transition-all ${
      active
        ? tone === "green"
          ? "bg-emerald-500/15 border-emerald-400/60 text-emerald-200 shadow-[0_0_16px_rgba(52,211,153,0.15)]"
          : "bg-cyan-500/15 border-cyan-400/60 text-cyan-200 shadow-[0_0_16px_rgba(0,240,255,0.15)]"
        : "bg-[#061423]/60 border-white/15 text-slate-300 hover:text-white hover:border-cyan-300/50"
    }`}
  >
    {children}
  </button>
);

export const SampleMapControls = ({
  layer, setLayer, showTransects, setShowTransects, unit, setUnit,
  hasPoints, clearPoints, compare, toggleCompare, onExport, exporting,
}) => (
  <div className="flex flex-wrap items-center gap-2" data-testid="sample-map-controls">
    <span className="inline-flex items-center gap-1.5 text-xs font-mono uppercase tracking-wider text-slate-300 mr-1">
      <Layers className="w-3.5 h-3.5" /> Layer
    </span>
    {VISIBLE_LAYERS.map((l) => (
      <Chip key={l.key} active={layer === l.key && !compare} onClick={() => setLayer(l.key)} testId={`sample-map-layer-${l.key}`}>
        {l.label}
      </Chip>
    ))}
    <Chip active={compare} onClick={toggleCompare} testId="sample-map-toggle-compare" tone="green">
      <span className="inline-flex items-center gap-1.5">
        <GitCompareArrows className="w-3.5 h-3.5" /> {SURVEY_YEARS.before} vs {SURVEY_YEARS.after}
      </span>
    </Chip>
    <span className="hidden sm:block w-px h-6 bg-white/15 mx-1" />
    <Chip active={showTransects} onClick={() => setShowTransects(!showTransects)} testId="sample-map-toggle-transects">
      <span className="inline-flex items-center gap-1.5"><Route className="w-3.5 h-3.5" /> Transects</span>
    </Chip>
    <div className="inline-flex rounded-lg border border-white/15 overflow-hidden text-sm font-mono" data-testid="sample-map-unit-toggle">
      {["ft", "m"].map((u) => (
        <button
          key={u}
          type="button"
          data-testid={`sample-map-unit-${u}`}
          onClick={() => setUnit(u)}
          className={`px-3 py-2 transition-colors ${unit === u ? "bg-cyan-500/20 text-cyan-200" : "bg-[#061423]/60 text-slate-300 hover:text-white"}`}
        >
          {u}
        </button>
      ))}
    </div>
    {hasPoints && (
      <button
        type="button"
        data-testid="sample-map-clear-measure"
        onClick={clearPoints}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold border border-amber-400/40 bg-amber-400/10 text-amber-200 hover:bg-amber-400/20 transition-colors"
      >
        <X className="w-3.5 h-3.5" /> Clear measurement
      </button>
    )}
    <button
      type="button"
      data-testid="sample-map-download-png"
      onClick={onExport}
      disabled={exporting}
      className="ml-auto inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-sm font-semibold bg-slate-100 text-slate-900 hover:bg-white disabled:opacity-60 transition-colors"
    >
      {exporting ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />} Download PNG
    </button>
    {!hasPoints && (
      <span className="w-full inline-flex items-center gap-1.5 text-xs text-slate-300">
        <Ruler className="w-3.5 h-3.5" /> {compare ? "Drag the handle to compare surveys · click two points to measure" : "Click two points to measure"}
      </span>
    )}
  </div>
);
